export function normalizeInternalAppRoute(value: unknown): string | null {
    if (typeof value !== "string") {
        return null;
    }

    const trimmed = value.trim();
    if (!trimmed || trimmed[0] !== "/" || trimmed.startsWith("//") || trimmed.startsWith("/\\")) {
        return null;
    }

    if (/[\u0000-\u001F\u007F]/.test(trimmed)) {
        return null;
    }

    const path = trimmed.split(/[?#]/, 1)[0].toLowerCase();
    if (path === "/authentication" || path.startsWith("/authentication/")) {
        return null;
    }

    return trimmed;
}
